import { render, staticRenderFns } from "./FooterBackBtn.vue?vue&type=template&id=6867e5df&"
import script from "./FooterBackBtn.vue?vue&type=script&lang=js&"
export * from "./FooterBackBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports